export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=404a0ceabfe5ba6e900730ddebba75803bc1e76b3e&name=revalidateCommunity!'